<script lang="ts" setup>
import { SancareBreadcrumb } from '@sancare/typescript-commons'
import { computed, onUnmounted, ref } from 'vue'
import { useRoute } from 'vue-router'

import { useBreadcrumb } from '@/breadcrumbs/useBreadcrumb'
import FindBar from '@/common/FindBar.vue'
import StayEditionsPage from '@/maintenance/StayEditionsPage.vue'
import StayStatusListPage from '@/maintenance/StayStatusListPage.vue'
import router from '@/router'
import { useStore } from '@/store'
import { PmsiTypeEnum } from '@/store/modules/settings/types'

const store = useStore()
const route = useRoute()

const { breadcrumbItems } = useBreadcrumb()

const props = defineProps<{
  pmsiId: string | null
  pmsiType: PmsiTypeEnum
}>()

const selectedTab = ref('editions')

const settingsUrlQuery = computed(() => route.query)

const stayHistoryRouteConfig = computed(() => {
  const params = {
    stayId: props.pmsiId,
    idType: props.pmsiType === PmsiTypeEnum.MCO ? 'rssId' : 'smrId',
  }
  return {
    name: `${props.pmsiType}-stay`,
    params,
    query: settingsUrlQuery.value
  }
})
async function handleSearch({ result, input }) {
  const pmsiIdProp = props.pmsiType === PmsiTypeEnum.MCO ? 'rssId' : 'smrId'
  if (!(pmsiIdProp in result)) {
    return
  }

  store.commit('logsReset')
  await router.push({
    name: 'maintenance-stay-history',
    params: {
      pmsiType: props.pmsiType,
      pmsiId: result[pmsiIdProp],
    }
  })
}

onUnmounted(() => {
  store.commit('logsReset')
})

</script>

<template>
  <div class="stay-history container">
    <sancare-breadcrumb
      v-if="$route.query.stayLabel"
      :items="breadcrumbItems"
    />
    <div class="stay-list-history card">
      <div class="card-body">
        <h1 class="mb-4">
          Rechercher un séjour
        </h1>
        <div class="row p-3">
          <find-bar
            class="w-100"
            @handle-submit="handleSearch"
            @handle-click="handleSearch"
          />
        </div>
      </div>
      <div
        v-if="pmsiId"
        class="card-body"
      >
        <h1 class="mb-4">
          Historique du séjour à l'identifiant {{ pmsiType === PmsiTypeEnum.MCO ? 'RSS' : 'SMR' }}
          <router-link
            class="btn btn-link"
            :to="stayHistoryRouteConfig"
          >
            {{ pmsiId }}
          </router-link>
        </h1>
        <ul class="row g-0 nav nav-tabs">
          <li class="nav-item col text-center home-list-tab">
            <span
              :class="{'active': selectedTab === 'editions'}"
              class="nav-link"
              @click="selectedTab = 'editions'"
            >
              Historique des actions sur le séjour
            </span>
          </li>
          <li class="nav-item col text-center home-list-tab">
            <span
              :class="{'active': selectedTab === 'consultations'}"
              class="nav-link"
              @click="selectedTab = 'consultations'"
            >
              Historique de consultations du séjour
            </span>
          </li>
        </ul>
        <stay-editions-page
          v-if="selectedTab === 'editions'"
          class="home-list p-3"
          :pmsi-id="pmsiId"
          :pmsi-type="pmsiType"
        />
        <stay-status-list-page
          v-if="selectedTab === 'consultations'"
          class="home-list p-3"
          :pmsi-id="pmsiId"
          :pmsi-type="pmsiType"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
h1 {
  font-size: 1.5rem;
}
</style>
